import { CircularProgress } from "@/components/display/CircularProgress";
import { formatMNOK, formatNOK } from "@/lib/format";

interface DisplayKpiSlideProps {
  achievedGeekKr: number;
  annualTargetKr: number;
  achievementPct: number | null;
  year: number;
}

/** TV slide: realised GEEK from completed projects against the combined annual unit targets. */
export function DisplayKpiSlide({ achievedGeekKr, annualTargetKr, achievementPct, year }: DisplayKpiSlideProps) {
  const remainingKr = Math.max(0, annualTargetKr - achievedGeekKr);
  return (
    <div className="flex h-full flex-col items-center justify-center gap-14">
      <div className="text-center">
        <p className="text-2xl font-medium uppercase tracking-[0.24em] text-muted-foreground">Hittil i {year}</p>
        <h2 className="mt-3 text-5xl font-bold">GEEK mot årsmål</h2>
      </div>
      <div className="flex items-center gap-16">
        <div className="flex flex-col items-center gap-2">
          <span className="text-9xl font-bold tabular-nums">{formatMNOK(achievedGeekKr)}</span>
          <span className="text-3xl text-muted-foreground">av {formatMNOK(annualTargetKr)}</span>
        </div>
        <CircularProgress value={achievementPct ?? 0} size={240} strokeWidth={20} label="av årsmål" />
      </div>
      <p className="text-3xl font-semibold">
        {remainingKr === 0 && annualTargetKr > 0 ? "Årsmålet er nådd! 🎉" : `${formatNOK(remainingKr)} gjenstår`}
      </p>
    </div>
  );
}
